import React from "react";
import * as CompareSectionStyles from "../styles/CompareSection";
import * as Flex from "../../../../../common-deprecated/styles/v2/toyota/globals/Flex";
import * as Text from "../../../../../common-deprecated/styles/v2/toyota/utilities/Text";
import * as Button from "../../../../../common-deprecated/styles/v2/toyota/components/Button";
import * as Toggle from "../../../../../common-deprecated/styles/v2/toyota/components/Toggle";
import { ToggleIconWrapper } from "../../../../../common-deprecated/styles/v2/toyota/globals/IconWrapper";
import Icon from "../../../../../common-deprecated/styles/v2/toyota/globals/Icon";
import { type CompareV2LabelType, CompareV2Label } from "../../../utils/labels";
import { theme } from "../../../../../common-deprecated/styles/v2/toyota/theme/toyotaTheme";
import { isRTL } from "../../../../../common-deprecated/settings/utils/commonSettingUtils";
import { useCompareV2Selector } from "../../../redux/store";
import { Ellipsis } from "../../../../../common-deprecated/styles/v2/toyota/utilities/Ellipsis";
import { trackCompareToggleSpecs } from "../../../utils/tracking";

type SectionHeaderType = {
    title: CompareV2LabelType;
    setOnlyShowDifferences: (show: boolean) => void;
    onlyShowDifferences: boolean;
    description: CompareV2LabelType;
    showToggleDifferences: boolean;
    toggleShowAllSpecs: (show: boolean) => void;
    showAllSpecs: boolean;
    isPdf?: boolean;
};

const SectionHeader = ({
    title,
    setOnlyShowDifferences,
    onlyShowDifferences,
    description,
    showToggleDifferences,
    toggleShowAllSpecs,
    showAllSpecs,
    isPdf,
}: SectionHeaderType): JSX.Element => {
    const commonSettings = useCompareV2Selector((state) => state.commonSettings);

    return (
        <CompareSectionStyles.Header>
            <CompareSectionStyles.Title>
                <CompareV2Label label={title} />
            </CompareSectionStyles.Title>
            <CompareSectionStyles.Description mb={3} isPdf={isPdf}>
                <Text.Default>
                    <CompareV2Label label={description} />
                </Text.Default>
            </CompareSectionStyles.Description>
            <Flex.Row mx={0}>
                {showToggleDifferences && (
                    <Flex.Col
                        width={{ _: 1, md: !isPdf ? 2 / 3 : 1 }}
                        mb={{ _: theme.space[4], md: 0 }}
                        textAlign={isRTL(commonSettings) ? "right" : "left"}
                        px={0}
                    >
                        {isPdf ? (
                            <Toggle.Wrapper>
                                <Toggle.Item active>
                                    <CompareV2Label
                                        label={
                                            onlyShowDifferences ? "compareBodyShowDifferences" : "compareBodyShowAll"
                                        }
                                    />
                                </Toggle.Item>
                            </Toggle.Wrapper>
                        ) : (
                            <Toggle.Wrapper>
                                <Toggle.Item
                                    onClick={() => {
                                        trackCompareToggleSpecs("see-all-specs");
                                        setOnlyShowDifferences(false);
                                    }}
                                    active={!onlyShowDifferences}
                                    aria-pressed={!onlyShowDifferences}
                                >
                                    <CompareV2Label label="compareBodyShowAll" />
                                </Toggle.Item>
                                <Toggle.Item
                                    onClick={() => {
                                        trackCompareToggleSpecs("see-differences-only");
                                        setOnlyShowDifferences(true);
                                    }}
                                    active={onlyShowDifferences}
                                    aria-pressed={onlyShowDifferences}
                                >
                                    <CompareV2Label label="compareBodyShowDifferences" />
                                </Toggle.Item>
                            </Toggle.Wrapper>
                        )}
                    </Flex.Col>
                )}
                {!isPdf ? (
                    <Flex.Col
                        display="flex"
                        width={{ _: 1, md: showToggleDifferences ? 1 / 3 : 1 }}
                        justifyContent={{ _: "flex-start", md: "flex-end" }}
                        px={0}
                    >
                        <Button.PrimaryGrey onClick={() => toggleShowAllSpecs(!showAllSpecs)} m={0}>
                            <Ellipsis maxWidth="100%">
                                <CompareV2Label
                                    label={showAllSpecs ? "compareBodyCollapseAll" : "compareBodyExpandAll"}
                                />
                            </Ellipsis>
                            <ToggleIconWrapper iconColor="primaryBlack" isDown={!showAllSpecs}>
                                <Icon variant="chevronDown" />
                            </ToggleIconWrapper>
                        </Button.PrimaryGrey>
                    </Flex.Col>
                ) : null}
            </Flex.Row>
        </CompareSectionStyles.Header>
    );
};

export default SectionHeader;
